import _toConsumableArray from "/Users/safepal/Desktop/work/spd/feedback-console/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import { onMounted } from "vue-demi"; // import { UseDark } from "@vueuse/components";

export default {
  name: "Header",
  // components: {
  //   UseDark,
  // },
  setup: function setup() {
    var addEvent = function addEvent(type, el, listener) {
      var all = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var selectEl = select(el, all);

      if (selectEl) {
        if (all) {
          selectEl.forEach(function (e) {
            return e.addEventListener(type, listener);
          });
        } else {
          selectEl.addEventListener(type, listener);
        }
      }
    };

    var select = function select(el) {
      var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      el = el.trim();

      if (all) {
        return _toConsumableArray(document.querySelectorAll(el));
      } else {
        return document.querySelector(el);
      }
    };
    /**
     * Mobile nav toggle
     */


    var mobileNavToggle = function mobileNavToggle() {
      select("#header").classList.toggle("pdtb-20");
      select("#navbar").classList.toggle("navbar-mobile");
      select("body").classList.toggle("overflow-hidden");
    };

    onMounted(function () {
      addEvent("click", ".mobile-nav-toggle", function (e) {
        mobileNavToggle();
      });
      addEvent("click", ".dropdown-off", function () {
        mobileNavToggle();
      });
      /**
       * Mobile nav dropdowns activate
       */

      addEvent("click", ".navbar .dropdown > a", function (e) {
        if (select("#navbar").classList.contains("navbar-mobile") && $(this).siblings(".dropdown-mobile").length) {
          e.preventDefault();
          $(this).siblings(".dropdown-mobile")[0].classList.toggle("dropdown-active");
          $(this).find(".bi-plus")[0].classList.toggle("d-none");
          $(this).find(".bi-dash")[0].classList.toggle("d-block");
        }
      }, true);
    });
    return {
      addEvent: addEvent,
      mobileNavToggle: mobileNavToggle,
      select: select
    };
  }
};